import * as React from 'react'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../lib/analytics'
import { EmbroideryFont } from '../../../../../types/graphql'
import { ErrorMessage, Label, SelectedOptionText, SelectionButton } from '../../shared-form-styles'

import { ButtonsWrapper } from './styles'

export const FontSelector: React.FC<{
  errorMessage?: string
  labelId: string
  onSelectFont(font: EmbroideryFont): void
  selectedFont: string | undefined
  fonts: EmbroideryFont[]
}> = ({ errorMessage, labelId, onSelectFont, selectedFont, fonts }) => {
  const { embroidery: fixtures } = useTranslation()

  return (
    <>
      <Label id={labelId}>
        {fixtures.modal.forms.fontSelector.label}{' '}
        <SelectedOptionText>{selectedFont}</SelectedOptionText>
      </Label>

      <ButtonsWrapper aria-labelledby={labelId}>
        {fonts.map((font, index) => (
          <SelectionButton
            aria-checked={font.name === selectedFont}
            fontStyle={font.name}
            isSelected={font.name === selectedFont}
            key={index}
            onClick={() => onSelectFont(font)}
            role='radio'
            type='button'
            {...trackEvent({
              category: 'embroidery',
              action: 'select font',
              label: font.name,
              value: font.name,
            })}
          >
            {font.name}
          </SelectionButton>
        ))}
      </ButtonsWrapper>

      {errorMessage && <ErrorMessage role='alert'>{errorMessage}</ErrorMessage>}
    </>
  )
}
